// extracted by mini-css-extract-plugin
export default {"facetMenu":"ix-z","fixed":"jx-z","nonLayerdFacets":"kx-z","productCount":"lx-z","facetBack":"mx-z","arrow":"nx-z","facetClose":"ox-z"};